import type { ZapiAction, ZapiParam } from '@weft/zapi-types';
import { CUSTOMERS_IDS_QUERY_PARAM, END_TIME_QUERY_PARAM, METERS_IDS_QUERY_PARAM, START_TIME_QUERY_PARAM } from '../../../api-definition-params';
import { StringArrayParamSchema } from '../../../shared-schemas';
import { GET_MEASUREMENTS_STATS_PATH } from './get-measurements-stats-path';
import { GetMeasurementsStatsResponseSchema } from './get-measurements-stats-response-schema';

export const METER_EVENT_NAME_QUERY_PARAM = {
  name: 'eventNames',
  location: 'query',
  schema: StringArrayParamSchema.optional(),
  required: false,
} as const satisfies ZapiParam;

export const GET_MEASUREMENTS_STATS_ACTION = {
  method: 'get',
  codeGenerationSettings: {
    actionText: 'get-measurements-stats',
  },
  queryParams: {
    [CUSTOMERS_IDS_QUERY_PARAM.name]: CUSTOMERS_IDS_QUERY_PARAM,
    [METERS_IDS_QUERY_PARAM.name]: METERS_IDS_QUERY_PARAM,
    [START_TIME_QUERY_PARAM.name]: START_TIME_QUERY_PARAM,
    [END_TIME_QUERY_PARAM.name]: END_TIME_QUERY_PARAM,
    [METER_EVENT_NAME_QUERY_PARAM.name]: METER_EVENT_NAME_QUERY_PARAM,
  },
  response: {
    name: 'GetMeasurementsStatsResponse',
    schema: GetMeasurementsStatsResponseSchema,
  },
  path: GET_MEASUREMENTS_STATS_PATH,
} satisfies ZapiAction;

export type GetMeasurementsStatsAction = typeof GET_MEASUREMENTS_STATS_ACTION;